import { MessageSquare } from "lucide-react";

/**
 * FeedbackPill — a small inline pill shown next to the logo in LandingNav.
 * Invites users to send feedback.
 *
 * (Previously labelled "Beta — free". Replaced with explicit feedback CTA
 * now that payments are still disabled but the beta framing is no longer
 * the primary message.)
 */
export function BetaPill() {
  return (
    <a
      href="/feedback"
      className="hidden sm:inline-flex items-center gap-1.5 text-[11px] font-semibold bg-emerald-50 text-emerald-700 px-2.5 py-1 rounded-full border border-emerald-100 hover:bg-emerald-100 transition-colors whitespace-nowrap"
      title="Send feedback"
    >
      <MessageSquare className="w-3.5 h-3.5" strokeWidth={1.75} aria-hidden="true" />
      Send feedback
    </a>
  );
}
